import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Header() {
  const { count, setCartOpen } = useCart();
  return (
    <>
      <header className="sticky top-0 z-40 bg-[#FBF9F5]/90 backdrop-blur-md border-b border-[#E8E2D5]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <a href="#beranda" data-testid="brand-logo-link" className="flex items-center gap-2 group">
            <span className="w-8 h-8 rounded-full bg-[#3D5A40] text-[#FBF9F5] flex items-center justify-center font-bold text-sm tracking-tighter shadow-sm">
              P
            </span>
            <span className="font-serif-display text-lg font-bold tracking-tight text-[#1E2B1D] leading-none">
              Puspita Florist
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-8 text-xs font-medium uppercase tracking-wider text-[#4A5746]">
            <a href="#kategori" data-testid="nav-kategori" className="hover:text-[#1E2B1D] transition-colors">Kategori</a>
            <a href="#katalog" data-testid="nav-katalog" className="hover:text-[#1E2B1D] transition-colors">Katalog</a>
            <a href="#layanan" data-testid="nav-layanan" className="hover:text-[#1E2B1D] transition-colors">Layanan Acara</a>
            <a href="#cara-pesan" data-testid="nav-cara-pesan" className="hover:text-[#1E2B1D] transition-colors">Cara Belanja</a>
            <a href="#faq" data-testid="nav-faq" className="hover:text-[#1E2B1D] transition-colors">FAQ</a>
          </nav>
          <div className="flex items-center gap-3">
            <a
              href="#katalog"
              data-testid="nav-pilih-bunga-btn"
              className="hidden sm:inline-flex px-4 py-2 text-xs font-semibold rounded-full border border-[#3D5A40] text-[#3D5A40] hover:bg-[#3D5A40] hover:text-[#FBF9F5] transition-colors"
            >
              Pilih Bunga
            </a>
            <button
              onClick={() => setCartOpen(true)}
              data-testid="cart-open-btn"
              className="relative p-2.5 rounded-full bg-[#3D5A40] text-[#FBF9F5] hover:bg-[#2F4632] transition-colors inline-flex items-center gap-2 px-4 shadow-sm text-xs font-medium"
            >
              <ShoppingBag className="w-4 h-4" />
              <span>
                Keranjang (<span className="font-bold" data-testid="cart-count">{count}</span>)
              </span>
            </button>
          </div>
        </div>
      </header>
      <div
        data-testid="service-area-strip"
        className="bg-[#EAE4D5] text-[#3D5A40] text-xs font-medium py-2 px-4 text-center border-b border-[#DCD5C5]"
      >
        Melayani pemesanan dan pengiriman rangkaian bunga segar ke seluruh Nusantara
      </div>
    </>
  );
}
